import { render, staticRenderFns } from "./LinealGraphs.vue?vue&type=template&id=620fe19c"
import script from "./LinealGraphs.vue?vue&type=script&lang=js"
export * from "./LinealGraphs.vue?vue&type=script&lang=js"
import style0 from "./LinealGraphs.vue?vue&type=style&index=0&id=620fe19c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports